"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Components = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _styledSystem = require("styled-system");
var _constant = require("../../styles/constant");
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;
const fit = (0, _styledSystem.variant)({
  prop: 'fit',
  variants: {
    small: {
      fontSize: (0, _constant.get)('fontSizes.s')
    },
    medium: {
      fontSize: (0, _constant.get)('fontSizes.m')
    },
    large: {
      fontSize: (0, _constant.get)('fontSizes.l')
    }
  }
});
const buttonFitVariant = (0, _styledSystem.variant)({
  prop: 'fit',
  variants: {
    small: {
      fontSize: (0, _constant.get)('fontSizes.s'),
      lineHeight: (0, _constant.get)('space.32'),
      padding: props => "".concat((0, _constant.get)('space.5')(props), " ").concat((0, _constant.get)('space.11')(props))
    },
    medium: {
      fontSize: (0, _constant.get)('fontSizes.m'),
      lineHeight: (0, _constant.get)('space.32'),
      padding: () => "".concat((0, _constant.get)('space.7'), " ").concat((0, _constant.get)('space.15'))
    },
    large: {
      fontSize: (0, _constant.get)('fontSizes.l'),
      lineHeight: (0, _constant.get)('space.32'),
      padding: props => "".concat((0, _constant.get)('space.11')(props), " ").concat((0, _constant.get)('space.23')(props))
    }
  }
});
const variants = {
  buttonFitVariant,
  fit
};
const Nav = _styledComponents["default"].nav(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  box-sizing: border-box;\n"])));
const TabsWrapper = _styledComponents["default"].div(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  border: ", ";\n  border-bottom: ", " solid ", ";\n  height: ", ";\n"])), (0, _constant.get)('space.0'), (0, _constant.get)('space.1'), (0, _constant.get)('colors.functional.grey.400'), (0, _constant.get)('space.42'));
const ButtonLeftRight = _styledComponents["default"].button(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n  height: ", ";\n  z-index: ", ";\n  background: none;\n  border: ", ";\n  cursor: pointer;\n  :disabled {\n    cursor: not-allowed;\n  }\n"])), (0, _constant.get)('space.42'), (0, _constant.get)('zindexes.1'), (0, _constant.get)('space.0'));
const UnorderedList = _styledComponents["default"].ul.withConfig({
  shouldForwardProp: prop => !['type'].includes(prop)
}).attrs(_ref => {
  let {
    type
  } = _ref;
  return {
    type
  };
})(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["\n  margin: ", ";\n  padding: ", ";\n  display: flex;\n  box-sizing: border-box;\n  position: relative;\n  width: ", ";\n  overflow: ", ";\n"])), (0, _constant.get)('space.0'), (0, _constant.get)('space.0'), props => props.type === 'overflow' ? 'max-content' : '100%', props => props.type === 'overflow' ? 'scroll' : 'unset');
const ListItem = _styledComponents["default"].li.withConfig({
  shouldForwardProp: prop => !['type'].includes(prop)
}).attrs(_ref2 => {
  let {
    onClick,
    type
  } = _ref2;
  return {
    onClick,
    type
  };
})(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2["default"])(["\n  margin-bottom: ", ";\n  position: relative;\n  display: flex;\n  justify-content: center;\n  box-sizing: border-box;\n  width: ", ";\n  border-bottom: ", " solid transparent;\n  &.active {\n    border-bottom: ", " solid ", ";\n  }\n  :hover {\n    border-bottom: ", " solid ", ";\n  }\n"])), (0, _constant.get)('space.0'), props => props.type === 'overflow' ? 'max-content' : props.type === 'justified' ? '100%' : 'unset', (0, _constant.get)('space.2'), (0, _constant.get)('space.2'), (0, _constant.get)('colors.functional.grey.900'), (0, _constant.get)('space.2'), (0, _constant.get)('colors.functional.grey.900'));
const ListItemButton = _styledComponents["default"].button(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2["default"])(["\n  background: none;\n  border: ", ";\n  cursor: pointer;\n  font-weight: ", ";\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: ", " ", ";\n  ", "\n"])), (0, _constant.get)('space.0'), (0, _constant.get)('fontWeights.regular'), (0, _constant.get)('space.10'), (0, _constant.get)('space.20'), variants.buttonFitVariant);
const ListItemButtonTitle = _styledComponents["default"].span(_templateObject7 || (_templateObject7 = (0, _taggedTemplateLiteral2["default"])(["\n  ", "\n  margin-left: ", ";\n"])), variants.fit, (0, _constant.get)('space.8'));
const Components = exports.Components = {
  Nav,
  TabsWrapper,
  ButtonLeftRight,
  UnorderedList,
  ListItem,
  ListItemButton,
  ListItemButtonTitle
};